<template>
  <div class="hero dark">
    <div class="container container-small row">
      <div class="col hero-content">
        <Blockquote
          v-if="quote && quote.text"
          :visible="visible || isMobile"
          :quote="quote" />
        <div v-if="content"
          class="hero-text slide-in"
          :class="{
            'visible': visible
          }">
          <p class="text-m paragraph">
            {{ content }}
          </p>
        </div>
      </div>
      <div class="hero-image" :style="'background-image: url(' + copierBg + ')'">
        <img :src="(isPhone ? copierImageMobile : copierImage)" ref="hero-image" alt="kopiarka" />
      </div>
    </div>
    <ScrollToNext v-if="!isPhone"/>
  </div>
</template>

<script>
import copierBg from '@/assets/images/cekt/kopiarka-bg.png'
import copierImage from '@/assets/images/cekt/kopiarka-static.png'
import copierImageGif from '@/assets/images/cekt/kopiarka.gif'
import copierImageGifHD from '@/assets/images/cekt/kopiarka-hd.gif'
import copierImageMobile from '@/assets/images/sections/centrum.png'

import { mapGetters } from 'vuex'
import Blockquote from '@/components/Blockquote.vue'
import ScrollToNext from '@/components/ScrollToNext.vue'

export default {
  name: 'HeroCentrum',
  props: ['content', 'quote', 'visible'],
  data () {
    return {
      copierBg: copierBg,
      copierImage: copierImage,
      copierImageMobile: copierImageMobile,
      gifLoaded: false,
      gifHDLoaded: false
    }
  },
  components: {
    Blockquote,
    ScrollToNext
  },
  computed: {
    ...mapGetters([
      'breakpoint'
    ]),
    isMobile () {
      return this.breakpoint === 'mobile' || this.breakpoint === 'tablet'
    },
    isPhone () {
      return this.breakpoint === 'mobile'
    }
  },
  methods: {
    loadImage (imgToLoad, loadedImage, loaded, callback) {
      const _t = this
      if (loaded) {
        _t.$refs[imgToLoad].src = loadedImage
        return false
      }
      let img = new Image()
      img.onload = () => {
        _t.$refs[imgToLoad].src = loadedImage
        _t.copierImage = loadedImage
        loaded = true

        if (typeof callback === 'function') {
          callback()
        }
      }
      img.src = loadedImage
    },
    loadAnimation (isMobile) {
      const _t = this
      if (isMobile) {
        _t.$refs['hero-image'].src = copierImageMobile
      } else {
        _t.loadImage('hero-image', copierImageGif, _t.gifLoaded, function () {
          if (!_t.gifHDLoaded) {
            _t.loadImage('hero-image', copierImageGifHD, _t.gifHDLoaded)
          }
        })
      }
    }
  },
  watch: {
    breakpoint (newVal, oldVal) {
      if (newVal === 'mobile') {
        this.loadAnimation(true)
      }
    }
  },
  mounted () {
    this.loadAnimation(this.isPhone)
  }
}
</script>

<style scoped lang="scss">
  .container {
    position: relative;
    min-height: 100%;
    padding-top: 84px;
  }
  .hero {
    background: #0e161e;
    min-height: 100vh;
    position: relative;

    &-text {
      margin: 0 0 50px 0;
      min-height: 100px;
      padding: 0;
      text-align: left;
      width: 100%;
      max-width: 350px;
    } // END .hero-text;

    &-content {
      align-items: flex-end;
      display: flex;
      flex-flow: column nowrap;
    } // END .hero-content;

    &-image {
      background: {
        color: transparent;
        repeat: no-repeat;
        position: 50% 50%;
        size: cover;
      }
      margin-bottom: ($gap-xl * -1);
      position: relative;
      top: ($gap-xl * -1);
      text-align: center;
      width: 100%;

      img {
        height: auto;
        width: auto;
        max-width: 100%;
      }
    } // END .hero-image;

    blockquote {
      margin: $gap-md 0 $gap-xl;
    }

    @include screen ('sm') {
      min-height: 720px;
      overflow: hidden;

      &-image {
        background-size: contain;
        margin: 0;
        min-height: 720px;
        height: 100%;
        left: 50%;
        position: absolute;
        top: 0;
        width: 50%;

        img {
          left: 50%;
          position: absolute;
          top: 50%;
          transform: translate(-50%, -50%);
          width: 130%;
          max-width: 130%;
          z-index: 10;
        }
      } // END .hero-image;

      &-text {
        margin: 0 0 50px 100px;
      } // END .hero-text;
    } // END @include screen ('sm');

    @include screen ('lg') {
      min-height: 100vh;

      &-image {
        min-height: 720px;
        height: calc(100vh - 84px);

        img {
          width: 150%;
          max-width: 150%;
        }
      } // END .hero-image;

      &-content {
        align-content: center;
        display: flex;
        flex-flow: row wrap;
        height: calc(100vh - 84px);

      } // END .hero-content;

      blockquote {
        margin-top: ($gap-xl * -2);
      }
    } // END @include screen ('md');

  } // END .hero;
</style>
